export const ShiftsDropDown = [
    {name:'Shift A',value:'ShiftA',startTime:'06:00:00',endTime:'12:00:00'},
    {name : 'Shift B',value:'ShiftB',startTime:'10:00:00',endTime:'14:00:00'},
    {name : 'Shift C',value:'ShiftC',startTime:'12:00:00',endTime:'18:00:00'},
    {name : 'General',value:'General',startTime:'10:00:00',endTime:'18:00:00'}
]